module.exports = __webpack_public_path__ + "img/step1.56c98b8a.png";